import { withAnimateValue } from './AnimateValue'
import { useSettings } from '../slices/settings'
import { travelTime } from '../utils'

const TravelTime = (props) => {
  const { value } = props
  const { speed } = useSettings()

  if (value == undefined) return null
  if (value < 0) return '--'
  return travelTime(value, speed)
}

export default withAnimateValue(TravelTime, 15)
